import { Badge, type BadgeProps } from "@/components/ui/badge";

const VARIANTS: Record<string, BadgeProps["variant"]> = {
  live: "success",
  executing: "default",
  parsed: "secondary",
  awaiting_approval: "default",
  closed: "secondary",
  cancelled: "outline",
  skipped: "outline",
  error: "destructive",
  open: "success",
  pending: "secondary",
  planned: "outline",
  simulated_open: "secondary",
  simulated_closed: "outline",
  failed: "destructive",
  submitted: "secondary",
  escalated: "destructive",
  resolving: "secondary",
  applied: "success",
  executed: "success",
  dry_run: "secondary",
};

const LABELS: Record<string, string> = {
  awaiting_approval: "needs approval",
  simulated_open: "simulated (open)",
  simulated_closed: "simulated (closed)",
  dry_run: "dry run",
};

export function StatusChip({ status }: { status: string }) {
  return (
    <Badge variant={VARIANTS[status] ?? "outline"} className="capitalize">
      {LABELS[status] ?? status.replace(/_/g, " ")}
    </Badge>
  );
}
